import React, { FC } from 'react';

import TextField, { TextFieldProps } from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

type Props = TextFieldProps;

const PriceInput: FC<Props> = props => (
  <TextField
    {...props}
    InputProps={{
      startAdornment: <InputAdornment position="start">€</InputAdornment>,
    }}
  />
);

export default PriceInput;
